'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
const className = classnames('cursor-pointer', 'text-pill-color', 'px-2 py-1', 'rounded-md', 'bg-pill-background-color');
const TextSelect = ({ children }) => (_jsx("span", { className: className, children: children }));
export default TextSelect;
